const Materials = () => import('../views/admin/materials/Materials.vue')
const MaterialForm = () => import('../views/admin/materials/MaterialForm.vue')
const MaterialCategories = () => import('../views/admin/materialCategories/MaterialCategories.vue')
const MaterialCategoryForm = () => import('../views/admin/materialCategories/MaterialCategoryForm.vue')
const MaterialUseCategories = () => import('../views/admin/materialUseCategories/MaterialUseCategories.vue')
const MaterialUseCategoryForm = () => import('../views/admin/materialUseCategories/MaterialUseCategoryForm.vue')

export default [
  {
    path: 'materials/:id',
    props: true,
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: MaterialForm
  },
  {
    path: 'materials',
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: Materials
  },
  {
    path: 'materialUseCategories',
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: MaterialUseCategories
  },
  {
    path: 'materialUseCategories/:id',
    props: true,
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: MaterialUseCategoryForm
  },
  {
    path: 'materialCategories',
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: MaterialCategories
  },
  {
    path: 'materialCategories/:id',
    props: true,
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: MaterialCategoryForm
  }
]
